import axios from 'axios';

export const loginService = async ({ username, password, remember }) => {
  const response = await axios.post('/login', {
    user: {
      email: username,
      password: password,
      checkLogin: remember,
    },
  });
  return response.data?.data;
};

export const logoutService = async () => {
  const response = await axios.post('/logout');
  return response.data?.data;
};

export const resetPasswordService = async (userName) => {
  const response = await axios.post('/forget-password', { username: userName });
  return response.data?.data;
};

export const contactUsService = async ({ name, email, phone, message }) => {
  const response = await axios.post('/contact-us', { name, email, phone, message });
  return response.data?.data;
};
